import(/* webpackMode: "eager" */ "/app/apps/ashtrom-industries/app/[locale]/not-found.tsx");
